<template>
  <div class="page-header" :style="{ backgroundImage: `url('/images/page-header-bg.jpg')` }">
    <div class="page-header-overlay"></div>
    <div class="page-header-content">
      <h1 class="page-title">{{ title }}</h1>
      <p v-if="subtitle" class="page-subtitle">{{ subtitle }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageHeader',
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
.page-header {
  position: relative;
  height: 300px;
  margin-top: -160px;
  padding-top: 160px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  display: flex;
  align-items: center;
  justify-content: center;
}

.page-header-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.6);
}

.page-header-content {
  position: relative;
  z-index: 2;
  text-align: center;
  padding: 0 20px;
}

.page-title {
  font-size: 48px;
  font-weight: 400;
  text-transform: uppercase;
  letter-spacing: 0.15em;
  color: white;
  margin: 0;
}

.page-subtitle {
  font-size: 18px;
  color: #ccc;
  margin-top: 15px;
  font-style: italic;
}

/* Tablet */
@media (min-width: 768px) and (max-width: 992px) {
  .page-header {
    height: 250px;
    margin-top: -100px;
    padding-top: 100px;
  }

  .page-title {
    font-size: 36px;
  }
}

/* Mobile */
@media (max-width: 767px) {
  .page-header {
    height: 200px;
    margin-top: 0;
    padding-top: 0;
  }

  .page-title {
    font-size: 28px;
    letter-spacing: 0.1em;
  }

  .page-subtitle {
    font-size: 14px;
  }
}
</style>